var lib_core = require("lib-core");

var PathBezierSegmentModel = require("./pathBezierSegmentModel.js");
var PathBezierSegmentView = require("./pathBezierSegmentView.js");
var PathArcSegmentModel = require("./pathArcSegmentModel.js");
var PathArcSegmentView = require("./pathArcSegmentView.js");

var PathSegmentView = require("./pathSegmentView.js");
var SelectableHandleView = require("./../../../interactionViews/selectableHandleView.js");
var DrawingElement = require("./../../../view/drawingElement.js");
var drawPathDataTo2D = require("./../../../view/renderData/drawPathDataTo2D.js");

var PathInteractionView = function (gui, interactionModel, parentGroup, layers, config, getAttributes) {
    var self  = this;
    this.gui = gui;

    this.interactionModel = interactionModel; // pathInteractionModel
    this.data = interactionModel.data; // pathData
    this.getAttributes = getAttributes;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.views = new lib_core.Collections.HashSet();
    this.layers = layers;

    this.parentGroup = parentGroup;

    this.initGroups(parentGroup, [layers.draw, layers.control]);
    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    $(this.controlGroup).mousedown(function(event){
        var cEvent = self.getMouseDownEvent(event);
        return self.gui.stateMachine.handle(cEvent);
    });

    this.interactionModel.selected.onChange(this, function (value) {
        self.setSelected(value);
    }, 10);

    this.data.onBubble(this, function () {
        self.gui.heavyHandler.scheduleHeavy('draw_view', self.draw, self, [], self); // TODO: hacky way to stop heavies from overwriting functions
    }, 10);

    var scheduleRebuild = function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.rebuild, self, [], self);
    };

    this.interactionModel.segments.onAdd("segmentAdded", scheduleRebuild);
    this.interactionModel.segments.onRemove("segmentRemoved", scheduleRebuild);
    this.interactionModel.pointHandles.onAdd("handleAdded", scheduleRebuild);
    this.interactionModel.pointHandles.onRemove("handleRemoved", scheduleRebuild);

    this.cameraModel.viewS.onChange(self, function(){
        self.gui.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
    },10);

    this.draw();
    this.rebuild();
};
lib_core.mixin(PathInteractionView, DrawingElement);

module.exports = PathInteractionView;

PathInteractionView.prototype.draw = function() {
    var self = this;
    $(this.elementSvgGroup).empty();

    if(!this.data.isAlive()) return;

    var attrs;
    if(this.getAttributes) attrs = this.getAttributes();

    drawPathDataTo2D(this.gui.svg, this.elementSvgGroup, this.data, attrs);

    this.drawControl();
};

PathInteractionView.prototype.drawControl = function() {
    $(this.controlGroup).empty();

    drawPathDataTo2D(this.gui.svg, this.controlGroup, this.data);
    this.control = $(":nth-last-child(1)",this.controlGroup);
    this.resizeControl();
};

PathInteractionView.prototype.resizeControl = function (event) {
    if(this.control) this.control.attr("stroke-width", this.data.strokeWidth() + 4 / this.cameraModel.viewS());
};

PathInteractionView.prototype.rebuild = function() {
    var self = this;

    this.removeSubViews();
    this.views.removeAll();

    this.interactionModel.segments.forEach(function(index, segment) {
        if(segment instanceof PathBezierSegmentModel)
            self.views.add(new PathBezierSegmentView(self.gui, segment, self.parentGroup, self.layers, self));
        else if(segment instanceof PathArcSegmentModel)
            self.views.add(new PathArcSegmentView(self.gui, segment, self.parentGroup, self.layers, self));
        else
            self.views.add(new PathSegmentView(self.gui, segment, self.parentGroup, self.layers, self));
    });

    this.interactionModel.pointHandles.forEach(function(index, handle){
        if(self.layers.interaction) {
            var handleView = new SelectableHandleView(self.gui, handle, self.parentGroup, self.layers);
            self.views.add(handleView);
        }
    });
};

PathInteractionView.prototype.removeSvg = function() {
    DrawingElement.removeSvg.call(this);
    this.removeSubViews();
};

PathInteractionView.prototype.removeSubViews = function() {
    this.views.forEach(function(view) {
        view.removeSvg();
    });
};

PathInteractionView.prototype.getMouseDownEvent = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent(event)
            .element( this.interactionModel )
            .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );
    return cEvent;
};
